import src from "IMAGE";
export default { src, width: 20, height: 24, blurWidth: 0, blurHeight: 0};
